module.exports = __webpack_public_path__ + "static/img/autumn_jianjiePic.6133cfd0.png";